import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Navbar from '../components/Navbar'
import { useAppDispatch } from '../hooks/reduxHooks'
import Product from '../screens/attractionsAndServices/Product'
import AddService from '../screens/attractionsAndServices/AddProduct'
import ProductDetail from '../screens/attractionsAndServices/ProductDetail'
import WorkersAndCarriers from '../screens/workersAndCarriers/WorkersAndCarriers'
import AddContractor from '../screens/workersAndCarriers/AddContractor'
import ContractorDetail from '../screens/workersAndCarriers/ContractorDetail'
import Clients from '../screens/clients/Client'
import AddClient from '../screens/clients/AddClient'
import ClientDetail from '../screens/clients/ClientDetail'
import EmailsAndSurveys from '../screens/emailsAndSurveys/overview/EmailsAndSurveys'
import SurveyDetail from '../screens/emailsAndSurveys/detail/SurveyDetail'
import Events from '../screens/events/overview/Events'
import AddEvent from '../screens/events/overview/AddEvent'
import EventDetail from '../screens/events/detail/EventDetail'
import Invoices from '../screens/invoices/Invoices'
import Login from '../screens/login/Login'
import Overview from '../screens/overview/Overview'
import Settings from '../screens/settings/Settings'
import Statistics from '../screens/statistics/Statistics'
import Unauthenticated from '../screens/login/Unauthenticated'
import { logoutUser, setAuthState } from '../services/redux/auth/auth-actions'
import { AUTH_LOCAL_STORAGE_KEY, parseJwtEncodedTokenAndGetReduxState } from '../services/redux/auth/auth-types'
import { RouteParameters, RouteConstants } from './navigation-types'
import ProtectedRoutes from './ProtectedRoutes'
import UnsavedChangesDialog from '../components/UnsavedChangesDialog'
import InvoiceDetail from '../components/invoices/InvoiceDetail'
import AccessDenied from '../screens/login/AccessDenied'
import Administration from '../screens/administration/Administration'

const MainNavigation: React.FC = () => {
    const dispatch = useAppDispatch()
    const [finishedAuthTokenRetrieval, setFinishedAuthTokenRetrieval] = useState<boolean>(false)

    useEffect(() => {
        console.debug('Initializing token from storage...')
        const token = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
        if (token) {
            console.debug('Token found, parsing...')
            const state = parseJwtEncodedTokenAndGetReduxState(token)
            dispatch(setAuthState(state))
        } else {
            console.debug('No token found...')
            dispatch(logoutUser())
        }
        setFinishedAuthTokenRetrieval(true)
    }, [dispatch])

    if (!finishedAuthTokenRetrieval) return <div>Loading token . . .</div>

    return (
        <BrowserRouter>
            <UnsavedChangesDialog />

            <Routes>
                <Route path={RouteConstants.login} element={<Login />} />
                <Route path={RouteConstants.unauthenticated} element={<Unauthenticated />} />
                <Route path={RouteConstants.invoices + RouteParameters.id} element={<InvoiceDetail />} />
                <Route path={RouteConstants.accessDenied} element={<AccessDenied />} />
                <Route
                    path='*'
                    element={
                        <>
                            <Navbar />
                            <ProtectedRoutes userRoutes={[RouteConstants.events, RouteConstants.settings]}>
                                <Routes>
                                    <Route path={RouteConstants.home} element={<Overview />} />
                                    <Route path={RouteConstants.clients} element={<Clients />} />
                                    <Route path={RouteConstants.addClient} element={<AddClient />} />
                                    <Route path={RouteConstants.clients + RouteParameters.id} element={<ClientDetail />} />
                                    <Route path={RouteConstants.events} element={<Events />} />
                                    <Route path={RouteConstants.addEvent} element={<AddEvent />} />
                                    <Route path={RouteConstants.events + RouteParameters.id} element={<EventDetail />} />
                                    <Route path={RouteConstants.product} element={<Product />} />
                                    <Route path={RouteConstants.addProduct} element={<AddService />} />
                                    <Route path={RouteConstants.product + RouteParameters.id} element={<ProductDetail />} />
                                    <Route path={RouteConstants.workersAndCarriers} element={<WorkersAndCarriers />} />
                                    <Route path={RouteConstants.addContact} element={<AddContractor />} />
                                    <Route
                                        path={RouteConstants.workersAndCarriers + RouteParameters.id}
                                        element={<ContractorDetail />}
                                    />
                                    <Route path={RouteConstants.statistics} element={<Statistics />} />
                                    <Route path={RouteConstants.invoices} element={<Invoices />} />
                                    <Route path={RouteConstants.emailsAndSurveys} element={<EmailsAndSurveys />} />
                                    <Route
                                        path={RouteConstants.emailsAndSurveys + RouteParameters.id}
                                        element={<SurveyDetail />}
                                    />
                                    <Route path={RouteConstants.settings} element={<Settings />} />
                                    <Route path={RouteConstants.administration} element={<Administration />} />
                                </Routes>
                            </ProtectedRoutes>
                        </>
                    }
                />
            </Routes>
        </BrowserRouter>
    )
}

export default MainNavigation
